import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { Link } from 'react-router-dom';

import { short } from '../common/formatting/date';
import { Button } from '../../../components';

import Questionnaire from './Questionnaire';

const RelatedResponseRow = ({ relatedResponse, questions }) => {
	const [showFullResponse, setShowFullResponse] = useState(false);
	return (
		<React.Fragment>
			<tr>
				<td>
					<Button
						icon={showFullResponse ? 'minus' : 'plus'}
						className="btn-link"
						onClick={() => setShowFullResponse(!showFullResponse)}
					/>
					{short(relatedResponse.response_dttm)}
				</td>
				<td>
					{isEmpty(relatedResponse.provider_response) ? (
						<em>No reponse given</em>
					) : (
						relatedResponse.provider_response
					)}
				</td>
				<td>
					{relatedResponse.evisit_recommended && (
						<em className="fa fa-fw fa-check" />
					)}
				</td>
				<td>
					{relatedResponse.evisitId && (
						<Link
							to={`/evisit/${relatedResponse.evisitId}`}
							target="_blank"
							rel="noreferrer"
						>
							View Visit
							<em className="fa fa-fw fa-external-link ml" />
						</Link>
					)}
				</td>
			</tr>
			{showFullResponse && (
				<tr>
					<td colSpan={3}>
						<Questionnaire
							questions={questions}
							responses={relatedResponse.care_quest_responses}
						/>
					</td>
				</tr>
			)}
		</React.Fragment>
	);
};

RelatedResponseRow.propTypes = {
	questions: PropTypes.array,
	relatedResponse: PropTypes.object.isRequired,
};

export default RelatedResponseRow;
